import React from "react";
import { Route, Routes as RouteDOM } from "react-router-dom";
import Home from "../components/Home/Home";

/**
 * Responsible for rendering the component as per route path
 */
export const Routes: React.FC = () => {

  return (
    <>
      <RouteDOM>
        <Route path="/" element={<Home />} />
      </RouteDOM>
    </>
  );
};
